import {ChevronLeftRounded} from '@mui/icons-material';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {isPRD} from '../../../utlis/vars';
import {Text} from '../@Text';
import {FmComponent} from '../types/types';
import './style.scss';

interface IBackButton extends FmComponent {
  to: string;
}

const BackButton = ({to, id, className, 'data-testid': dataTestId}: IBackButton): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <div
      className={`fm-back-btn${className ? ` ${className}` : ''}`}
      id={id}
      data-testid={isPRD ? undefined : dataTestId}
      onClick={() => navigate(to)}
    >
      <ChevronLeftRounded/>
      <Text>Back</Text>
    </div>
  );
};

export default BackButton;
